import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import MapControlButtons from '../../MapControlButtons/MapControlButtons';

// Helpers
import { constructStaticMapLink } from '../../../services/MapboxService/MapboxService';

// styles
import * as styles from './CompanyMap.scss';

class StaticCompanyMap extends Component {
  state = {
    staticMapLink: ''
  };

  componentDidMount() {
    this.initialiseStaticMap();
  }

  componentWillReceiveProps(newProps) {
    const localeIsChanged = (newProps.locale && newProps.locale !== this.props.locale);
    const pinsTypeIsChanged = (newProps.pinsType && newProps.pinsType !== this.props.pinsType);
    const isMobileIsChanged = (newProps.isMobile !== this.props.isMobile);

    if (localeIsChanged || pinsTypeIsChanged || isMobileIsChanged) {
      this.initialiseStaticMap(newProps.locale, newProps.groupedProperties, newProps.isMobile);
    }
  }

  shouldComponentUpdate(newProps, newState) {
    const isMobileIsChanged = (newProps.isMobile !== this.props.isMobile);
    const localeIsChanged = (newProps.locale && newProps.locale !== this.props.locale);
    const pinsTypeIsChanged = (newProps.pinsType && newProps.pinsType !== this.props.pinsType);
    const mapLinkIsChanged = newState.staticMapLink !== this.state.staticMapLink;

    return (localeIsChanged || pinsTypeIsChanged || mapLinkIsChanged || isMobileIsChanged);
  }

  initialiseStaticMap = (
    locale = this.props.locale,
    groupedProperties = this.props.groupedProperties,
    isMobile = this.props.isMobile
  ) => {
    const keys = Object.keys(groupedProperties);
    const pins = keys.map(item => item.split('|').reverse().join(','));
    const metrics = { width: 1280, height: 500 };

    if (isMobile) {
      metrics.width = (global && global.document && global.document.body.clientWidth) || 375;
      metrics.height = 360;
    }

    const staticMapLink = constructStaticMapLink(
      pins,
      metrics,
      undefined,
      this.props.locale
    );

    this.setState({ staticMapLink });
  };

  render() {
    return (
      <div
        className={styles.staticMap}
        onClick={this.props.switchToDynamicMap}
      >
        <img src={this.state.staticMapLink || ''} alt="" />
        <MapControlButtons />
      </div>
    );
  }
}

StaticCompanyMap.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  groupedProperties: PropTypes.object,
  pinsType: PropTypes.string,
  switchToDynamicMap: PropTypes.func
};

export default StaticCompanyMap;
